const nftmarketaddress = '0x422c3a901Fc4723099F50C6097d2475e55EB9fd5';

export default nftmarketaddress;
